<template>
    <v-col :cols="12" :sm="12" :md="12">
      <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>
  
      <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  
      <DataTable
        v-show="mostrarSkeleton == false"
        :tableTitle="'Solicitações de Registro'"
        :tableHeader="headers"
        :tableRows="listaSolicitacoesRegistro"
        :isEditStatusSolicitacao="true"
        v-on:datatable-updatestatusrow="modalDeAtualizar"
      ></DataTable>
  
      <SkeletonTable
        v-show="mostrarSkeleton == true"
        :showSkeletonTable="mostrarSkeleton"
      ></SkeletonTable>
  
      <Loading :open="loading" />
  
      <ModalCustomSize
        :modalSize="modalCustomSize.size"
        :isTheModalOpen="modalCustomSize.isOpen"
        :modalButtonText="modalCustomSize.buttonText"
        :modalFormTitle="modalCustomSize.formTitle"
        :modalType="modalCustomSize.modalType"
        :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
        :isModalButtonVisible="modalCustomSize.isButtonsVisible"
        :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
        v-on:formmodal-close="modalCustomSize.isOpen = false"
        v-on:formmodal-action="acoesModal"
      >
        <v-row>
          <v-col cols="12">
            <AlertasModal
              :tipo="alertaModal.tipo"
              :texto="alertaModal.texto"
            ></AlertasModal>
          </v-col>
        </v-row>
  
        <v-form v-model="tudoValido">
          <v-row>
            <v-col cols="12">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.nomePaciente" 
                name="nomePaciente" 
                autocomplete="off" 
                label="Nome Paciente" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.cpfPaciente" 
                name="cpfPaciente" 
                autocomplete="off" 
                label="CPF Paciente" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.dataNascimentoFormatada" 
                name="dataNascimento" 
                autocomplete="off" 
                label="Data Nascimento" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.nomaMae" 
                name="nomaMae" 
                autocomplete="off" 
                label="Nome completo Mãe" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.nomaPai" 
                name="nomaPai" 
                autocomplete="off" 
                label="Nome completo Pai" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.cepPaciente" 
                name="cepPaciente" 
                autocomplete="off" 
                label="CEP" 
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="modalCustomSize.dadosModal.numeroResidencia" 
                name="numeroResidencia" 
                autocomplete="off" 
                label="Numero Residencia" 
                disabled
              ></v-text-field>
            </v-col>
            
            <v-expand-transition>
              <v-col v-if="modalCustomSize.dadosModal.fotoComprovanteResidencia" cols="6">
                <div class="grey--text text--darken-4 body-1 font-weight-black">• Comprovante Residencia</div>
                <img
                  v-bind:src="modalCustomSize.dadosModal.fotoComprovanteResidencia"
                  width="200"
                  height="250"
                  style="object-fit: contain;"
                />
              </v-col>
            </v-expand-transition>
            
            <v-expand-transition>
              <v-col v-if="modalCustomSize.dadosModal.fotoPaciente" cols="6">
                <div class="grey--text text--darken-4 body-1 font-weight-black">• Foto Paciente</div>
                <img
                  v-bind:src="modalCustomSize.dadosModal.fotoPaciente"
                  width="200"
                  height="250"
                  style="object-fit: contain;"
                />
              </v-col>
            </v-expand-transition>

            <v-col cols="12">
              <v-autocomplete
                v-model="modalCustomSize.dadosModal.indicadorStatus"
                label="Consolidar registro"
                :items="listaStatus"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </ModalCustomSize>
    </v-col>
  </template>
  
  <script>
  import store from "@/store/index";
  import axios from "../plugins/axios";
  import Alertas from "../components/Alertas.vue";
  import AlertasModal from "../components/AlertasModal.vue";
  import AlertaSnackbar from "../components/AlertaSnackbar.vue";
  import DataTable from "@/components/DataTable2.vue";
  import SkeletonTable from "../components/SkeletonTable";
  import Loading from "../components/Loading.vue";
  import ModalCustomSize from "@/components/ModalCustomSize.vue";
  
  export default {
    components: {
      Alertas,
      AlertasModal,
      AlertaSnackbar,
      DataTable,
      SkeletonTable,
      Loading,
      ModalCustomSize
    },
  
    data: () => ({
      //#region Paginação 
      page: 1,
      search: null,
      total: null,
      //#endregion
  
      //#region Alertas
      alerta: {
        texto: "",
        tipo: ""
      },
  
      alertaSocket: {
        texto: "",
        tipo: "",
      },
  
      alertaModal: {
        texto: "",
        tipo: "",
      },
  
      alertaSnackbar: {
        mostrar: false,
        texto: null,
        cor: "red"
      },
      //#endregion
  
      rules: {
        requerido: (value) => value != null && value != "" || "Requer o campo!",
      },
  
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
  
      headers: [
        {
          text: "Nº",
          value: "solicitacaoRegistro.numeroSolicitacaoRegistro",
        },
        {
          text: "Nº Paciente",
          value: "paciente.numeroPaciente",
        },
        {
          text: "Nome Paciente",
          value: "paciente.descricaoNome",
        },
        {
          text: "CPF Paciente",
          value: "paciente.descricaoCpf",
        },
        {
          text: "Data Nascimento",
          value: "paciente.dataNascimento",
        },
        {
          text: "Data da Solicitação",
          value: "solicitacaoRegistro.dataSolicitacao",
        },
        {
          text: "Status",
          value: "solicitacaoRegistro.indicadorStatus",
        },
        { text: "Ações", value: "actions", sortable: false },
      ],
  
      modalCustomSize: {
        size: "1600",
        isOpen: false,
        isEdit: false,
        formTitle: "",
        buttonText: "Concluir",
        isButtonsVisible: false,
        isButtonsDisabled: false,
        isLoadingRequestDisable: false,
        dadosModal: {
          numeroSolicitacaoRegistro: null,
          dataSolicitacao: null,
          indicadorStatus: null,
          numeroPaciente: null,
          nomePaciente: null,
          cpfPaciente: null,
          dataNascimento: null,
          nomaMae: null,
          nomaPai: null,
          cepPaciente: null,
          numeroResidencia: null,
          fotoComprovanteResidencia: null,
          fotoPaciente: null,
        },
      },
  
      loading: false,
      tudoValido: false,
      mostrarSkeleton: true,
  
      listaSolicitacoesRegistro: [],
      listaStatus: [
        {
          value: 0,
          text: "Registro Solicitado"
        },
        {
          value: 1,
          text: "Registro Consolidado"
        }
      ],
    }),
  
    created() {
      this.mostrarSkeleton = true;
      this.inicializar();
    },
  
    watch: {
      tudoValido() {
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
      },
    },
  
    methods: {
      //#region LISTAGENS
      async inicializar() {
        try {
          const response = await axios.put('listarSolicitacaoRegistro', {}, this.config);
          this.listaSolicitacoesRegistro = response.data;
          console.log( this.listaSolicitacoesRegistro)
          
        } catch (error) {
          console.log(error);
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = 'erro';
        } finally {
          this.mostrarSkeleton = false;
        }
      },
      //#endregion
  
      //#region EVENTOS REQUISIÇÃO
      async acoesModal() {
        try {
          this.loading = true;
          if(this.modalCustomSize.isEdit) {
            await this.atualizar();
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
  
      async atualizar() {
        try {
          this.alertaModal.tipo = '';
          await axios.put('solicitacaoRegistro', this.modalCustomSize.dadosModal, this.config);
          this.alerta.texto = "Solicitação atualizada";
          this.alerta.tipo = "sucesso";
  
          this.modalCustomSize.isOpen = false;
          this.mostrarSkeleton = true;
          this.inicializar();
        } catch (error) {
          console.log(error);
          this.alertaModal.texto = error.response.data.message;
          this.alertaModal.tipo = 'erro';
        }
      },
      //#endregion
  
      //#region FUNÇÕES MODAL
      async modalDeAtualizar(solicitacaoRegistroSelecionado) {
        this.loading = true;
        try {
          this.alertaModal.tipo = "";
          
          this.modalCustomSize.dadosModal.numeroSolicitacaoRegistro = solicitacaoRegistroSelecionado.solicitacaoRegistro.numeroSolicitacaoRegistro;
          this.modalCustomSize.dadosModal.dataSolicitacao = this.formataDataBanco(solicitacaoRegistroSelecionado.solicitacaoRegistro.dataSolicitacao);
          this.modalCustomSize.dadosModal.indicadorStatus = solicitacaoRegistroSelecionado.solicitacaoRegistro.indicadorStatus;
          this.modalCustomSize.dadosModal.numeroPaciente = solicitacaoRegistroSelecionado.paciente.numeroPaciente;
          this.modalCustomSize.dadosModal.nomePaciente = solicitacaoRegistroSelecionado.paciente.descricaoNome;
          this.modalCustomSize.dadosModal.cpfPaciente = solicitacaoRegistroSelecionado.paciente.descricaoCpf;
          this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(solicitacaoRegistroSelecionado.paciente.dataNascimento);
          this.modalCustomSize.dadosModal.dataNascimentoFormatada = this.formatarData(this.modalCustomSize.dadosModal.dataNascimento);
          this.modalCustomSize.dadosModal.nomaMae = solicitacaoRegistroSelecionado.paciente.nomeMae;
          this.modalCustomSize.dadosModal.nomaPai = solicitacaoRegistroSelecionado.paciente.nomePai;
          this.modalCustomSize.dadosModal.cepPaciente = solicitacaoRegistroSelecionado.paciente.descricaoCep;
          this.modalCustomSize.dadosModal.numeroResidencia = solicitacaoRegistroSelecionado.paciente.numeroResidencia;
          this.modalCustomSize.dadosModal.fotoComprovanteResidencia = null;
          this.modalCustomSize.dadosModal.fotoPaciente = null;
          if(solicitacaoRegistroSelecionado.paciente.caminhoComprovante){
           this.modalCustomSize.dadosModal.fotoComprovanteResidencia =  "data:image/jpeg;base64,"+solicitacaoRegistroSelecionado.paciente.caminhoComprovante;
         }

         if(solicitacaoRegistroSelecionado.paciente.caminhoFoto){
           this.modalCustomSize.dadosModal.fotoPaciente =  "data:image/jpeg;base64,"+solicitacaoRegistroSelecionado.paciente.caminhoFoto;
         }
          
        } catch (error) {
          console.log(error);
        } finally {
          this.modalCustomSize.formTitle = "Atualizar status Solicitação";
          this.modalCustomSize.isEdit = true;
          this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
          this.modalCustomSize.isButtonsVisible = true;
          this.modalCustomSize.isOpen = true;
          this.loading = false;
        }
      },
      //#endregion

      //#region FORMATADORES
      formataDataBanco(data) {
        if(data) {
          var ano  = data.split("-")[0];
          var mes  = data.split("-")[1];
          var dia  = data.split("-")[2];
          var dia2  = dia.substring(0,2)
          
          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else {
          return null
        }
      },

      formatarData(date) {
        if (!date) return null;

        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
      
      analizarData(date) {
        if (!date) return null;

        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();
        
        if (!/^[0-9]*?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      //#endregion
    },
  };
  </script>
  